module.exports = __webpack_public_path__ + "static/img/bg50.e6f6745e.png";